// Runtime-config accessor, inlined at build time by Next via next.config.js
// `env` (Next 15 removed `publicRuntimeConfig` support for static exports).
// Values are provided as NEXT_PUBLIC_APP_* environment variables during
// `next build` and are replaced statically in both server and client bundles.
//
// Each reference must be a direct `process.env.X` literal so Next's
// DefinePlugin inlines it — do not refactor to a loop or a map.
//
// Jest does not inline these, so tests can set process.env.NEXT_PUBLIC_APP_*
// or rely on the defaults below.
const getPublicRuntimeConfig = () => ({
  apolloUrl: process.env.NEXT_PUBLIC_APP_APOLLO_URL,
  eventStream: process.env.NEXT_PUBLIC_APP_EVENT_STREAM_URL,
  eventStreamToken: process.env.NEXT_PUBLIC_APP_EVENT_STREAM_TOKEN,
  name: process.env.NEXT_PUBLIC_APP_NAME || 'development',
  apiMocking: process.env.NEXT_PUBLIC_APP_API_MOCKING,
  gitSha: process.env.NEXT_PUBLIC_APP_GIT_SHA || 'local',
  updaterAPIURL: process.env.NEXT_PUBLIC_APP_UPDATER_API_URL,
  growthbookSdkKey: process.env.NEXT_PUBLIC_APP_GROWTHBOOK_SDK_KEY,
  growthbookApiHost: process.env.NEXT_PUBLIC_APP_GROWTHBOOK_API_HOST,
  googlePlacesAPIKey: process.env.NEXT_PUBLIC_APP_GOOGLE_PLACES_API_KEY,
  smartyStreetsAPIKey: process.env.NEXT_PUBLIC_APP_SMARTY_STREETS_API_KEY,
  remoteConfigBaseUrl: process.env.NEXT_PUBLIC_APP_REMOTE_CONFIG_BASE_URL,
  localBuyflowBaseUrl: process.env.NEXT_PUBLIC_APP_LOCAL_BUYFLOW_BASE_URL,
  basePath: process.env.NEXT_PUBLIC_APP_BASE_PATH || '/provider',
});

export default getPublicRuntimeConfig;
